import React, { Component } from 'react';

    function Loader() {
    return <div>
        <img src="assets/images/loader.gif" alt="Loading" className="loader"/>
    </div>;
  }

export default Loader;